import { render, staticRenderFns } from "./BaseScrollable.vue?vue&type=template&id=6c26e913&"
import script from "./BaseScrollable.vue?vue&type=script&lang=ts&"
export * from "./BaseScrollable.vue?vue&type=script&lang=ts&"
import style0 from "./BaseScrollable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports